// isShipSense property name is returned from the backend. The backend has not been updated to reflect
// the final feature name, SmartFill, so some properties passed from the backend are still the old name.
export const IS_SMARTFILL_APPLIED = 'isShipSense';
export const SMARTFILL_DATA = 'smartFillData';
export const MAX_SHIPMENTS_WITH_SMARTFILL_APPLIED_FOR_BANNER_DISPLAY = 50;
